import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { AnalyticsTabs, AnalyticsTab } from '../components/AnalyticsTabs';
import { EmptyState } from '../components/EmptyState';
import { AcceptanceTab } from '../components/AcceptanceTab';
import { AuthenticationTab } from '../components/AuthenticationTab';
import { DisputesTab } from '../components/DisputesTab';
import { PaymentMethodsTab } from '../components/PaymentMethodsTab';
import { RefundsTab } from '../components/RefundsTab';
import { FeedbackModal } from '../components/FeedbackModal';
import { Granularity } from '../components/GranularitySelector';
interface DateRange {
  start: Date;
  end: Date;
}
export function PaymentAnalytics() {
  const {
    t
  } = useTranslation("analytics");
  const navigate = useNavigate();
  const location = useLocation();
  const getInitialTab = (): AnalyticsTab => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab') as AnalyticsTab;
    return tab || 'acceptance';
  };
  const [activeTab, setActiveTab] = useState<AnalyticsTab>(getInitialTab());
  const [dateRange, setDateRange] = useState<DateRange>({
    start: new Date(new Date().setDate(new Date().getDate() - 90)),
    end: new Date()
  });
  const [granularity, setGranularity] = useState<Granularity>('weekly');
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set('tab', activeTab);
    navigate(`${location.pathname}?${params.toString()}`, {
      replace: true
    });
  }, [activeTab]);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab') as AnalyticsTab;
    if (tab && tab !== activeTab) {
      setActiveTab(tab);
    }
  }, [location.search]);
  const handleTabChange = (tab: AnalyticsTab) => {
    setActiveTab(tab);
  };
  const renderTabContent = () => {
    const contentVariants = {
      initial: {
        opacity: 0,
        y: 10
      },
      animate: {
        opacity: 1,
        y: 0
      },
      exit: {
        opacity: 0,
        y: -10
      }
    };
    return <AnimatePresence mode="wait" data-id="element-2539">
        <motion.div key={activeTab} variants={contentVariants} initial="initial" animate="animate" exit="exit" transition={{
        duration: 0.2
      }} data-id="element-2540">
          
          {activeTab === 'acceptance' ? <AcceptanceTab dateRange={dateRange} granularity={granularity} onDateRangeChange={setDateRange} onGranularityChange={setGranularity} data-id="element-2541" /> : activeTab === 'authentication' ? <AuthenticationTab dateRange={dateRange} granularity={granularity} onDateRangeChange={setDateRange} onGranularityChange={setGranularity} data-id="element-2542" /> : activeTab === 'disputes' ? <DisputesTab dateRange={dateRange} granularity={granularity} onDateRangeChange={setDateRange} onGranularityChange={setGranularity} data-id="element-2543" /> : activeTab === 'payment-methods' ? <PaymentMethodsTab dateRange={dateRange} granularity={granularity} onDateRangeChange={setDateRange} onGranularityChange={setGranularity} data-id="element-2544" /> : activeTab === 'refunds' ? <RefundsTab dateRange={dateRange} granularity={granularity} onDateRangeChange={setDateRange} onGranularityChange={setGranularity} data-id="element-2545" /> : <div className="bg-white rounded-lg border border-gray-200 p-8" data-id="element-2546">
              <EmptyState message={`${activeTab.charAt(0).toUpperCase() + activeTab.slice(1)} analytics content coming soon`} submessage="This section will display detailed analytics charts and tables." data-id="element-2547" />
            
            </div>}
        </motion.div>
      </AnimatePresence>;
  };
  return <div data-id="element-2548">
      <div className="mb-6" data-id="element-2549">
        <div className="flex items-center justify-between mb-4" data-id="element-2550">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-2551">
            {t("pages.PaymentAnalytics.payment_analytics")}
          </h1>
          <button onClick={() => setShowFeedbackModal(true)} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-2552">
            
            {t("components.FeedbackModal.share_feedback")}
          </button>
        </div>
        <AnalyticsTabs activeTab={activeTab} onChange={handleTabChange} data-id="element-2553" />
      </div>

      <div data-id="element-2554">{renderTabContent()}</div>

      <FeedbackModal isOpen={showFeedbackModal} onClose={() => setShowFeedbackModal(false)} data-id="element-2555" />
      
    </div>;
}